import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";
import { FaMicrophone, FaLinkedin } from "react-icons/fa";
import DiscussionPanelists from "../HomeComonents/DiscussionPanelists-homepage-section";
import SummerThemeWrapper from "../Home/SummerThemeWrapper";

const SummerMembersMeet2026Details = () => {
  const headingVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.1,
        type: "spring",
        stiffness: 120,
      },
    }),
  };

  const title = "MSB Association summer Members Meet 2026, sponsored by peratera";

  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.05,
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };

  return (
    <SummerThemeWrapper>
      <div>
        <Helmet>
          <title>Summer Members Meet 2026 | Money Service Business Association UK</title>
          <meta name="description" content="Highlights and insights from the MSB Association Summer Members Meet 2026 sponsored by peratera." />
          <meta property="og:title" content="Summer Members Meet 2026 | MSB Association UK" />
          <meta property="og:description" content="Join us in reviewing the highlights from our 2026 Summer Members Meet in London." />
          <meta property="og:type" content="website" />
        </Helmet>

        <main className="page_content">
          <style>{`
        .speaker-card-hover {
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }
        .speaker-card-hover:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.12) !important;
        }
        .speaker-card-hover hr {
          transition: width 0.4s ease;
        }
        .speaker-card-hover:hover hr {
          width: 95% !important;
        }

        .speaker-name-link {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          color: inherit;
          text-decoration: none;
          transition: color 0.3s ease;
        }
        .linkedin-static-icon {
          color: #0a66c2;
          font-size: 26px;
          display: flex;
          transition: all 0.3s ease;
        }
        .linkedin-static-icon:hover {
          transform: scale(1.2);
          color: #004182;
        }
        
        .btn_learn_more {
          background: #f7931e;
          color: #fff !important;
          padding: 12px 25px;
          border-radius: 50px;
          font-weight: 700;
          transition: all 0.3s ease;
          display: inline-block;
          margin-top: 20px;
          text-decoration: none;
          box-shadow: 0 4px 15px rgba(247, 147, 30, 0.2);
          width: 100%;
        }
        .btn_learn_more:hover {
          background: #e6821d;
          transform: translateY(-3px);
          box-shadow: 0 6px 20px rgba(247, 147, 30, 0.3);
        }
      `}</style>
          {/* Page Header */}
          <section
            id="overview"
            className="page_header text-center section_decoration overflow-hidden"
            style={{ background: "#333" }}
          >
            <div className="container">
              <motion.h1
                className="page_title text-white"
                initial="hidden"
                animate="visible"
                style={{
                  display: "block",
                  textAlign: "center",
                  width: "100%",
                  maxWidth: "1100px",
                  margin: "0 auto"
                }}
              >
                {title.split(" ").map((word, wordIndex) => (
                  <span key={`word-${wordIndex}`} style={{ display: "inline-block", whiteSpace: "nowrap" }}>
                    {word.split("").map((letter, charIndex) => {
                      const globalIndex = title.split(" ").slice(0, wordIndex).join(" ").length + (wordIndex > 0 ? 1 : 0) + charIndex;
                      return (
                        <motion.span
                          key={`char-${wordIndex}-${charIndex}`}
                          custom={globalIndex}
                          initial="hidden"
                          animate="visible"
                          variants={letterVariants}
                          style={{
                            display: "inline-block",
                            whiteSpace: "pre",
                          }}
                        >
                          {letter}
                        </motion.span>
                      );
                    })}
                    {/* Add space after word if not the last word */}
                    {wordIndex < title.split(" ").length - 1 && (
                      <span style={{ display: "inline-block", width: "0.3em" }}>&nbsp;</span>
                    )}
                  </span>
                ))}
              </motion.h1>
              <ul className="breadcrumb_nav unordered_list justify-content-center">
                <li>
                  <NavLink to="/events">Events</NavLink>
                </li>
                <li className="active">
                  <a href="#!">summer Members Meet 2026</a>
                </li>
              </ul>
            </div>
          </section>

          {/* Content Section */}
          <section className="contact_section section_space bg-white">
            <div className="container">
              <div className="item_details_content p-3">
                <div className="d-flex justify-content-end mb-3">
                  <NavLink to="/events" className="btn bg-primary text-dark">
                    &larr; Back
                  </NavLink>
                </div>

                <img
                  className="img-fluid rounded-2"
                  src="assets/images/meetup-2026/annual-meetup-2026.png"
                  alt="MSB summer Members Meet 2026"
                  onError={(e) => { e.target.src = "https://placehold.co/1200x600?text=MSB+summer+Meet+2026+Main+Banner"; }}
                />

                <h3 className="mt-4 mb-3 text-center text-dark">
                  MSB Association summer Members Meet 2026, sponsored by peratera
                </h3>

                <h4 className="text-dark text-center mb-5" style={{ color: "#f7931e !important" }}>
                  What an evening! A powerful gathering of insight, leadership & industry collaboration
                </h4>
                <p className="mb-2 text-dark">
                  On <strong>Thursday, 16th April 2026</strong>, the MSB community came together once again—live in London—for an unforgettable evening of connection, insight, and forward-thinking discussions.
                </p>
                <p className="mb-2 text-dark">
                  Hosted at the prestigious <strong>Leonardo Royal Hotel St Paul’s</strong>, the event welcomed <strong>90+ industry professionals</strong>, including leaders, compliance experts, fintech innovators, and decision-makers from across the Money Service Business sector.
                </p>
                <p className="mb-2 text-dark">
                  From in-depth discussions on regulatory expectations to real-world challenges in scaling payment operations, the evening was filled with meaningful conversations that inspired new ideas and strengthened industry connections.
                </p>
                <p className="text-dark">
                  This was more than just an event—it was a moment to reflect, connect, and shape the future of the MSB industry.
                </p>

                {/* Discussion Panel Section - Classic Design */}
                <div className="full-width-white-section py-5 mt-5">
                  <div className="container">
                    <div className="row">
                      <div className="col-12 mb-5">
                        <div className="d-flex align-items-center justify-content-center mb-4">
                          <div style={{ flex: 1, height: '2px', background: '#f7931e', borderRadius: '2px' }}></div>
                          <div className="schedule-date fw-bold fs-5 mx-3" style={{ whiteSpace: 'nowrap' }}>
                            Insightful Panel Discussion
                          </div>
                          <div style={{ flex: 1, height: '2px', background: '#f7931e', borderRadius: '2px' }}></div>
                        </div>
                        <div className="text-center">
                          <p className="text-dark mb-1">This year’s panel focused on:</p>
                          <p className="fw-bold text-dark mb-3">
                            “Scaling MSB Payment Operations Across Fiat and Digital Rails with Trust at the Core”
                          </p>
                          <p className="text-dark mb-0">Our distinguished panelists shared powerful insights:</p>
                        </div>
                      </div>
                    </div>

                    <div className="row g-4 justify-content-center">
                      {/* Teresa Cameron */}
                      <div className="col-lg-4 col-md-6 px-lg-4">
                        <div
                          className="blog_post_block h-100 speaker-card-hover"
                          style={{
                            padding: "50px 30px",
                            border: "1px solid #ffd700",
                            borderRadius: "24px",
                            background: "#fff",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            boxShadow: "0 10px 25px rgba(0,0,0,0.05)"
                          }}
                        >
                          {/* Portrait Container - Enlarged to 230px */}
                          <div style={{ position: 'relative', width: '230px', height: '250px', marginBottom: '40px' }}>
                            <div style={{ position: 'absolute', top: '-12px', left: '-15px', width: '70px', height: '70px', background: '#f7931e', zIndex: 0 }}></div>
                            <div style={{ position: 'absolute', bottom: '-12px', right: '-15px', width: '90px', height: '90px', borderRight: '2px solid #000', borderBottom: '2px solid #000', zIndex: 0 }}></div>
                            <img
                              src="assets/images/discussion-panalist/MS.-Teresa-Cameron.png"
                              alt="Ms. Teresa Cameron"
                              style={{ width: "100%", height: "100%", objectFit: "cover", position: 'relative', zIndex: 1, filter: "grayscale(100%)", backgroundColor: "#f8f9fa", borderRadius: "4px" }}
                            />
                          </div>

                          <div className="text-center w-100">
                            <h4 className="text-dark fw-bold mb-2 d-flex align-items-center justify-content-center gap-2">
                              Ms. Teresa Cameron
                              <a
                                href="https://www.linkedin.com/in/teresa-cameron-fct-cgma-1466a916"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="linkedin-static-icon"
                                title="View LinkedIn Profile"
                              >
                                <FaLinkedin />
                              </a>
                            </h4>
                            <p className="small mb-2" style={{ color: "#aaa", fontWeight: "600" }}>CEO</p>
                            <div className="mb-4">
                              <img
                                src="assets/images/discussion-panalist/clear-junction-logo.png"
                                alt="peratera Logo"
                                style={{ maxHeight: "25px", maxWidth: "130px" }}
                              />
                            </div>
                            <hr style={{ borderTop: "1px solid #f1f1f1", width: "85%", margin: "0 auto 25px" }} />
                            <p className="text-dark small mb-0 px-2" style={{ lineHeight: "1.7", opacity: "0.9" }}>
                              Spoke on the technical challenges and innovations in integrating fiat and digital payment rails.
                            </p>
                            <NavLink to="/discussion-panel-2026#teresa-cameron" className="btn_learn_more">
                              Learn More
                            </NavLink>
                          </div>
                        </div>
                      </div>

                      {/* James Borley */}
                      <div className="col-lg-4 col-md-6 px-lg-4">
                        <div
                          className="blog_post_block h-100 speaker-card-hover"
                          style={{
                            padding: "50px 30px",
                            border: "1px solid #ffd700",
                            borderRadius: "24px",
                            background: "#fff",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            boxShadow: "0 10px 25px rgba(0,0,0,0.05)"
                          }}
                        >
                          {/* Portrait Container - Enlarged to 230px */}
                          <div style={{ position: 'relative', width: '230px', height: '250px', marginBottom: '40px' }}>
                            <div style={{ position: 'absolute', top: '-12px', left: '-15px', width: '70px', height: '70px', background: '#f7931e', zIndex: 0 }}></div>
                            <div style={{ position: 'absolute', bottom: '-12px', right: '-15px', width: '90px', height: '90px', borderRight: '2px solid #000', borderBottom: '2px solid #000', zIndex: 0 }}></div>
                            <img
                              src="assets/images/discussion-panalist/MR.-James-Borley.png"
                              alt="Mr. James Borley"
                              style={{ width: "100%", height: "100%", objectFit: "cover", position: 'relative', zIndex: 1, filter: "grayscale(100%)", backgroundColor: "#f8f9fa", borderRadius: "4px" }}
                            />
                          </div>

                          <div className="text-center w-100">
                            <h4 className="text-dark fw-bold mb-2 d-flex align-items-center justify-content-center gap-2">
                              Mr. James Borley
                              <a
                                href="https://www.linkedin.com/in/james-borley-281669114"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="linkedin-static-icon"
                                title="View LinkedIn Profile"
                              >
                                <FaLinkedin />
                              </a>
                            </h4>
                            <p className="small mb-2" style={{ color: "#aaa", fontWeight: "600" }}>Director</p>
                            <div className="mb-4">
                              <img
                                src="assets/images/discussion-panalist/complyport-logo.jpg"
                                alt="Complyport Logo"
                                style={{ maxHeight: "25px", maxWidth: "130px" }}
                              />
                            </div>
                            <hr style={{ borderTop: "1px solid #f1f1f1", width: "85%", margin: "0 auto 25px" }} />
                            <p className="text-dark small mb-0 px-2" style={{ lineHeight: "1.7", opacity: "0.9" }}>
                              Highlighted key regulatory frameworks and compliance considerations for scalable growth.
                            </p>
                            <NavLink to="/discussion-panel-2026#james-borley" className="btn_learn_more">
                              Learn More
                            </NavLink>
                          </div>
                        </div>
                      </div>

                      {/* Oliver Calma */}
                      <div className="col-lg-4 col-md-6 px-lg-4">
                        <div
                          className="blog_post_block h-100 speaker-card-hover"
                          style={{
                            padding: "50px 30px",
                            border: "1px solid #ffd700",
                            borderRadius: "24px",
                            background: "#fff",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            boxShadow: "0 10px 25px rgba(0,0,0,0.05)"
                          }}
                        >
                          {/* Portrait Container - Enlarged to 230px */}
                          <div style={{ position: 'relative', width: '230px', height: '250px', marginBottom: '40px' }}>
                            <div style={{ position: 'absolute', top: '-12px', left: '-15px', width: '70px', height: '70px', background: '#f7931e', zIndex: 0 }}></div>
                            <div style={{ position: 'absolute', bottom: '-12px', right: '-15px', width: '90px', height: '90px', borderRight: '2px solid #000', borderBottom: '2px solid #000', zIndex: 0 }}></div>
                            <img
                              src="assets/images/discussion-panalist/Mr.-Oliver-Calma.png"
                              alt="Mr. Oliver Calma"
                              style={{ width: "100%", height: "100%", objectFit: "cover", position: 'relative', zIndex: 1, filter: "grayscale(100%)", backgroundColor: "#f8f9fa", borderRadius: "4px" }}
                            />
                          </div>

                          <div className="text-center w-100">
                            <h4 className="text-dark fw-bold mb-2 d-flex align-items-center justify-content-center gap-2">
                              Mr. Oliver Calma
                              <a
                                href="https://www.linkedin.com/in/oliver-calma-cfa-53976020"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="linkedin-static-icon"
                                title="View LinkedIn Profile"
                              >
                                <FaLinkedin />
                              </a>
                            </h4>
                            <p className="small mb-2" style={{ color: "#aaa", fontWeight: "600" }}>Founder & CEO</p>
                            <div className="mb-4">
                              <img
                                src="assets/images/discussion-panalist/bc-remit-logo.jpg"
                                alt="BC Remit Logo"
                                style={{ maxHeight: "25px", maxWidth: "130px" }}
                              />
                            </div>
                            <hr style={{ borderTop: "1px solid #f1f1f1", width: "85%", margin: "0 auto 25px" }} />
                            <p className="text-dark small mb-0 px-2" style={{ lineHeight: "1.7", opacity: "0.9" }}>
                              Shared real-world business experiences and practical operational insights.
                            </p>
                            <NavLink to="/discussion-panel-2026#oliver-calma" className="btn_learn_more">
                              Learn More
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-5">
                      <div className="col-12 text-center">
                        <p className="text-dark small mt-2">
                          Together, the panel delivered a balanced perspective across technology, compliance, and business strategy.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>


                {/* Keynote Address Section */}
                <div className="mt-5">
                  <div className="d-flex align-items-center justify-content-center mb-4">
                    <div style={{ flex: 1, height: '2px', background: '#f7931e', borderRadius: '2px' }}></div>
                    <div className="schedule-date fw-bold fs-5 mx-3" style={{ whiteSpace: 'nowrap' }}>
                      Keynote Address: Expert Insights
                    </div>
                    <div style={{ flex: 1, height: '2px', background: '#f7931e', borderRadius: '2px' }}></div>
                  </div>
                  <div className="text-center">
                    <p className="text-dark mb-5">
                      Our keynote speakers delivered insightful and thought-provoking sessions, bringing both regulatory depth and innovation to the forefront.
                    </p>
                  </div>

                  <div className="row justify-content-center g-5">
                    {/* Saima Hanif KC */}
                    <div className="col-lg-5">
                      <div
                        className="blog_post_block h-100 speaker-card-hover"
                        style={{
                          padding: "50px 30px",
                          border: "1px solid #ffd700",
                          borderRadius: "24px",
                          background: "#fff",
                          boxShadow: "0 10px 25px rgba(0,0,0,0.05)"
                        }}
                      >
                        {/* Showaround Image Container - Enlarged to 280px */}
                        <div className="showaround-container mb-5" style={{ position: 'relative', width: '280px', margin: '0 auto' }}>
                          {/* Orange Accent */}
                          <div style={{ position: 'absolute', top: '-18px', left: '-18px', width: '90px', height: '90px', background: '#f7931e', zIndex: 0 }}></div>
                          {/* Black L-Border Accent */}
                          <div style={{ position: 'absolute', bottom: '-18px', right: '-18px', width: '130px', height: '130px', borderRight: '3px solid #000', borderBottom: '3px solid #000', zIndex: 0 }}></div>
                          {/* Portrait */}
                          <img
                            src="assets/images/our-team/Saima.png"
                            alt="Ms. Saima Hanif KC"
                            style={{ width: '280px', height: '300px', objectFit: 'cover', position: 'relative', zIndex: 1, filter: 'grayscale(100%) brightness(1.1)', boxShadow: '0 10px 30px rgba(0,0,0,0.1)', borderRadius: "4px" }}
                            onError={(e) => { e.target.src = "https://placehold.co/400x400?text=Saima+Hanif+KC"; }}
                          />
                        </div>

                        <div className="post_content text-center">
                          <h4 className="text-dark fw-bold mb-2 d-flex align-items-center justify-content-center gap-2">
                            Ms. Saima Hanif KC
                            <a
                              href="https://www.linkedin.com/in/saima-hanif-kc-4947662/"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="linkedin-static-icon"
                              title="View LinkedIn Profile"
                            >
                              <FaLinkedin />
                            </a>
                          </h4>
                          <p className="small mb-3" style={{ color: "#888" }}>Keynote Speaker</p>
                          <hr style={{ borderTop: "1px solid #eee", width: "80%", margin: "0 auto 15px" }} />
                          <div className="d-flex align-items-center mb-4 text-start">
                            <div
                              className="d-flex align-items-center justify-content-center"
                              style={{
                                background: "#f7931e",
                                minWidth: "45px",
                                height: "45px",
                                borderRadius: "50%",
                                marginRight: "15px",
                                boxShadow: "0 4px 10px rgba(247, 147, 30, 0.2)",
                                flexShrink: 0
                              }}
                            >
                              <FaMicrophone size={22} color="#fff" />
                            </div>
                            <h6 className="text-dark fw-bold mb-0" style={{ lineHeight: "1.4" }}>
                              “From Evidence to Governance: How Regulators Assess MSB Conduct in AML Breaches”
                            </h6>
                          </div>
                          <ul className="text-start text-dark small" style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                            <li>Regulatory expectations in AML compliance</li>
                            <li>Lessons from recent enforcement cases</li>
                            <li>Importance of strong governance frameworks</li>
                            <li>The evolving role of compliance leadership</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    {/* Vishal Patil */}
                    <div className="col-lg-5">
                      <div
                        className="blog_post_block h-100 speaker-card-hover"
                        style={{
                          padding: "50px 30px",
                          border: "1px solid #ffd700",
                          borderRadius: "24px",
                          background: "#fff",
                          boxShadow: "0 10px 25px rgba(0,0,0,0.05)"
                        }}
                      >
                        {/* Showaround Image Container - Enlarged to 280px */}
                        <div className="showaround-container mb-5" style={{ position: 'relative', width: '280px', margin: '0 auto' }}>
                          {/* Orange Accent */}
                          <div style={{ position: 'absolute', top: '-18px', left: '-18px', width: '90px', height: '90px', background: '#f7931e', zIndex: 0 }}></div>
                          {/* Black L-Border Accent */}
                          <div style={{ position: 'absolute', bottom: '-18px', right: '-18px', width: '130px', height: '130px', borderRight: '3px solid #000', borderBottom: '3px solid #000', zIndex: 0 }}></div>
                          {/* Portrait */}
                          <img
                            src="assets/images/meetup-2026/vishal-sir-26.png"
                            alt="Mr. Vishal Patil"
                            style={{ width: '280px', height: '300px', objectFit: 'cover', position: 'relative', zIndex: 1, filter: 'grayscale(100%) brightness(1.1)', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}
                            onError={(e) => { e.target.src = "https://placehold.co/400x400?text=Vishal+Patil"; }}
                          />
                        </div>

                        <div className="post_content text-center">
                          <h4 className="text-dark fw-bold mb-2 d-flex align-items-center justify-content-center gap-2">
                            Mr. Vishal Patil
                            <a
                              href="https://uk.linkedin.com/in/vishal-patil-78181914"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="linkedin-static-icon"
                              title="View LinkedIn Profile"
                            >
                              <FaLinkedin />
                            </a>
                          </h4>
                          <p className="small mb-3" style={{ color: "#888" }}>Keynote Speaker</p>
                          <hr style={{ borderTop: "1px solid #eee", width: "80%", margin: "0 auto 15px" }} />
                          <div className="d-flex align-items-center mb-4 text-start">
                            <div
                              className="d-flex align-items-center justify-content-center"
                              style={{
                                background: "#f7931e",
                                minWidth: "45px",
                                height: "45px",
                                borderRadius: "50%",
                                marginRight: "15px",
                                boxShadow: "0 4px 10px rgba(247, 147, 30, 0.2)",
                                flexShrink: 0
                              }}
                            >
                              <FaMicrophone size={22} color="#fff" />
                            </div>
                            <h6 className="text-dark fw-bold mb-0" style={{ lineHeight: "1.4" }}>
                              “Stablecoin in Money Remittance”
                            </h6>
                          </div>
                          <ul className="text-start text-dark small" style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                            <li>The growing role of stablecoins in cross-border payments</li>
                            <li>Opportunities and challenges in adoption</li>
                            <li>The future of digital assets in the industry</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p className="mt-5 text-dark">
                    <strong>
                      Together, these sessions provided a well-rounded perspective, helping MSBs better understand regulatory expectations while exploring emerging innovations.
                    </strong>
                  </p>
                </div>





                {/* Event Highlights Section */}
                <div className="row mb-5 mt-5">
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="schedule-date fw-bold fs-5">
                      Event Highlights
                    </div>
                    <div className="schedule-card">
                      <div className="schedule-item mb-2">
                        <ul className="text-dark">
                          <li>90+ attendees from MSBs, fintech, legal, and compliance sectors</li>
                          <li>Engaging panel discussions and keynote sessions</li>
                          <li>Interactive Q&A with real-world industry challenges</li>
                          <li>High-value networking opportunities</li>
                          <li>Refreshments, event goodies, and meaningful conversations</li>
                          <li>A collaborative environment driving industry progress</li>
                        </ul>
                      </div>
                      <p className="text-dark">
                        <strong>
                          <em>
                            “This wasn’t just a meetup—it was a platform for real conversations, practical insights, and industry collaboration.”
                          </em>
                        </strong>
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6 col-12">
                    <div
                      className="p-0 overflow-hidden"
                      style={{
                        background: "#000",
                        borderRadius: "15px",
                        border: "2px solid #f7931e",
                        boxShadow: "0 15px 35px rgba(0,0,0,0.15)",
                        aspectRatio: "16 / 9",
                        width: "100%",
                        marginTop: "40px"
                      }}
                    >
                      <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/TSv9xk0M6Ag?rel=0&autoplay=1&mute=1&loop=1&playlist=TSv9xk0M6Ag&controls=0&modestbranding=1"
                        title="MSB Association summer Members Meet 2026 Highlights"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      ></iframe>
                    </div>
                  </div>
                </div>

                {/* Footer CTA Section */}
                <div
                  className="p-5 mt-5 text-center"
                  style={{ background: "#f7931e", borderRadius: "10px" }}
                >
                  <div className="row align-items-center">
                    <div className="col-lg-12">
                      <h2 className="heading_text mb-4 text-white">
                        What’s Next?
                      </h2>
                      <p className="mb-3 text-white">
                        <strong>
                          This marks another successful year of bringing the MSB community together. We are excited to continue growing this platform for collaboration, innovation, and knowledge sharing.
                        </strong>
                      </p>
                      <h5 className="text-white">
                        Stay Tuned - Engage with the MSB Network
                      </h5>
                      <NavLink
                        className="btn-black bg-primary btn-rounded mt-4"
                        to="/overview#membership-form"
                      >
                        <span className="btn_label">Become a Member</span>
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </main>
      </div>
    </SummerThemeWrapper>
  );
};

export default SummerMembersMeet2026Details;

